import { FC } from 'react';

import { useSelector } from '@hh.ru/front-static-app';
import { RequestData } from '@hh.ru/front-static-app/lib/types';

declare global {
    /* eslint-disable-next-line @typescript-eslint/no-empty-object-type */
    interface LuxRequest extends RequestData {}
}

const ProxyComponents: FC = () => {
    const pageName = useSelector(({ request }) => request.pageName);

    switch (pageName) {
        case 'test':
            return <>test proxy component</>;
    }

    return null;
};

export default ProxyComponents;
